import { Box, Typography, Grid } from '@mui/material';
import { MetricCard } from './MetricCard';
import { SellerPlatformFeesInterface } from '../../../../../Models/SellerPlan';

interface MetricsGridProps {
    platformFees: SellerPlatformFeesInterface;
    maxGigsAllowed?: number | null;
    maxOrdersPerMonth?: number | null;
    prioritySupport?: boolean;
}

export const MetricsGrid = ({ 
    platformFees, 
    maxGigsAllowed, 
    maxOrdersPerMonth, 
    prioritySupport 
}: MetricsGridProps) => {
    return (
        <Box sx={{ marginBottom: 3 }}>
            <Typography sx={{ 
                fontSize: '0.7rem',
                fontWeight: 700,
                color: '#64748b',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                marginBottom: 2
            }}>
                📊 Plan Details
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <MetricCard
                        label="Platform Fee"
                        value={`${platformFees.feesPercent}%`}
                        subtext={platformFees.maxCap ? `Max cap: ₹${platformFees.maxCap}` : undefined}
                    />
                </Grid>
                <Grid item xs={6}>
                    <MetricCard
                        label="Max Gigs"
                        value={maxGigsAllowed ?? '∞'}
                    />
                </Grid>
                <Grid item xs={6}>
                    <MetricCard
                        label="Orders/Month"
                        value={maxOrdersPerMonth ?? '∞'}
                    />
                </Grid>
                <Grid item xs={6}>
                    <MetricCard
                        label="Priority Support"
                        value={prioritySupport ? '✓' : '✗'}
                        isHighlighted={prioritySupport}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};
